const title = '潮州侨联'
// 域名
const host = process.env.VUE_APP_BASE_API
// 后台的授权URL
const wxAuthUrl = host + '/wx/pageAuth'
// 与后台对接校验的字符串
const wxSignature = 'Ms7uTc9sY7lwR0mf1G'
// 前端域名
const frontHost = 'https://gzh.czxqgtsy.com'

export default {
  title, host, wxAuthUrl, wxSignature, frontHost
}



// WEBPACK FOOTER //
// ./src/utils/globalConst.js